const action_instances_dashboard_messages = {
  page_title: ['action_instances_dashboard>>page_title', 'Action instances dashboard'],
  help_title: ['action_instances_dashboard>>help_title', 'Action instances dashboard – how it works?'],
  help_body: [
    'action_instances_dashboard>>help_body',
    'Active templates with counts of instances valid today (A), completed among those (K), and instances created in the last 365 days (T). Filters apply to the template pivot and summary metrics. Hover a template name for linked assets. Click A or K to open the instance list with links to details.',
  ],
  help_button: ['action_instances_dashboard>>help_button', 'How it works'],
  kpi_completion: ['action_instances_dashboard>>kpi_completion', 'Completion rate'],
  kpi_sum_a: ['action_instances_dashboard>>kpi_sum_a', 'Total valid instances (A)'],
  kpi_sum_k: ['action_instances_dashboard>>kpi_sum_k', 'Total completed valid (K)'],
  column_template: ['action_instances_dashboard>>column_template', 'Template name'],
  column_area: ['action_instances_dashboard>>column_area', 'Area'],
  column_subarea: ['action_instances_dashboard>>column_subarea', 'Subarea'],
  column_a: ['action_instances_dashboard>>column_a', 'Valid instances (A)'],
  column_k: ['action_instances_dashboard>>column_k', 'Completed valid (K)'],
  column_t: ['action_instances_dashboard>>column_t', 'Last 365 days (T)'],
  hover_assets_title: ['action_instances_dashboard>>hover_assets_title', 'Linked assets'],
  dialog_title_a: ['action_instances_dashboard>>dialog_title_a', 'Valid instances for template'],
  dialog_title_k: ['action_instances_dashboard>>dialog_title_k', 'Completed valid instances for template'],
  dialog_empty: ['action_instances_dashboard>>dialog_empty', 'No instances in this selection.'],
  dialog_column_instance: ['action_instances_dashboard>>dialog_column_instance', 'Instance'],
  dialog_column_asset: ['action_instances_dashboard>>dialog_column_asset', 'Asset'],
  load_more_instances: ['action_instances_dashboard>>load_more_instances', 'Show more instances'],
};

export default action_instances_dashboard_messages;
